/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchInvitedReferralsResponse } from './search-invited-referrals-response';


export interface SearchInvitedReferralsResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchInvitedReferralsResponse> | null;
}

